import { ImageStorageSetting } from './image-storage-setting';
import type { MaasImageStorageBlockProps } from './types';

/** 模型实例镜像存储能力块 */
export function MaasImageStorageBlock({ form }: MaasImageStorageBlockProps) {
  return <ImageStorageSetting form={form} />;
}
